"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
const ParseGeometry = __importStar(require("./parse-geometry2"));
const ParseCaseFreon = __importStar(require("./parse-case-freon"));
const ParseCoeffInterval = __importStar(require("./parse-coeff-interval"));
const ParseVelocity = __importStar(require("./parse-velocity"));
function parse(si, file) {
    const geometries = ParseGeometry.parse(file[0], false);
    const heatingCaseFreon = ParseCaseFreon.parse(file[1].slice(0, 8));
    const coolingCaseFreon = ParseCaseFreon.parse(file[1].slice(8, 16));
    const coeffInterval = ParseCoeffInterval.parse(file[2]);
    const heatingVelocities = ParseVelocity.parse(file[3].map(r => [r[0], r[1], r[2]]));
    const coolingVelocities = ParseVelocity.parse(file[3].map(r => [r[0], r[3], r[4]]));
    if (geometries.length !== coolingVelocities.input.length) {
        throw new Error("Number of geometries does not match number of velocities");
    }
    return {
        velocityUnits: {
            type: "velocity-units",
            velocity: heatingVelocities.units.velocity,
            dryPower: heatingVelocities.units.power,
            dryPressure: heatingVelocities.units.pressure,
            wetPower: coolingVelocities.units.power,
            wetPressure: coolingVelocities.units.pressure
        },
        rows: geometries.map((g, ix) => ({
            id: g.id,
            input: Object.assign(Object.assign({}, coeffInterval), { si: si, coilId: g.id, geometry: g.geometry, heatingCaseFreon: heatingCaseFreon, coolingCaseFreon: coolingCaseFreon, coolingVelocityInput: coolingVelocities.input[ix], heatingVelocityInput: heatingVelocities.input[ix] })
        }))
    };
}
//# sourceMappingURL=parse-freon-cooling.js.map